import { useEffect } from "react";

export default function useScrollLock(locked: boolean) {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (locked) {
      const scrollY = window.scrollY;
      body.dataset.scrollY = String(scrollY);

      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";

      html.style.overscrollBehavior = "contain";
    } else {
      const y = Number(body.dataset.scrollY || "0");

      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      document.documentElement.style.overscrollBehavior = "";
      if (y) window.scrollTo(0, y);
    }

    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      document.documentElement.style.overscrollBehavior = "";
    };
  }, [locked]);
}
